import { render, staticRenderFns } from "./backOff.vue?vue&type=template&id=2ea63b40&"
import script from "./backOff.vue?vue&type=script&lang=ts&"
export * from "./backOff.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports